module.exports = __webpack_public_path__ + "static/specialists-slideshow-03-d26595629cf191c76d9dcdea5a970906.jpg";